import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Downshift from 'downshift'
import cx from 'classnames'

import FormLabel from '../FormLabel'
import StatusBadge from '../StatusBadge'

import arrowDown from '../graphics/arrow-down.svg'

import ALLOWED_STATUSES from '../config/allowedStatuses'

export class Dropdown extends Component {
  render() {
    const {
      label,
      value,
      items,
      className,
      onChange,
      errorMessage,
      id,
      disabled = false,
    } = this.props
    return (
      <Downshift
        itemToString={(item) => (item['text'] ? item.text : item.toString())}
        onChange={(item) => onChange(item.value)}
        selectedItem={items.find((item) => item.value === value) || items[0]}
      >
        {({
          getLabelProps,
          getToggleButtonProps,
          getMenuProps,
          getItemProps,
          highlightedIndex,
          selectedItem,
          toggleMenu,
          inputValue,
          isOpen,
        }) => (
          <div className={cx('relative f6', className)} id={id}>
            {label && (
              <FormLabel
                title={label}
                {...getLabelProps()}
                onClick={toggleMenu}
              />
            )}
            <button
              {...getToggleButtonProps()}
              className={cx(
                'db border-box w-100 navy ba ph2 br3 shadow-1 flex items-center pointer',
                disabled ? 'bg-light-gray' : 'bg-white',
                errorMessage ? 'b--red' : 'b--silver'
              )}
              style={{
                paddingTop: '0.6rem',
                paddingBottom: '0.6rem',
                boxShadow: errorMessage ? `#c81349 0 0 3px` : null,
              }}
              title={errorMessage}
            >
              {ALLOWED_STATUSES.includes(selectedItem.value) && (
                <StatusBadge
                  status={selectedItem.value}
                  size={16}
                  className="mr1"
                />
              )}
              <span className="ph2">{inputValue}</span>
              <img
                src={arrowDown}
                alt=""
                className="ml-auto pl3 pr2 pv2 bl b--silver"
              />
            </button>
            {items && items.length > 0 && isOpen && (
              <div
                className="absolute z-1 w-100 ph2"
                style={{
                  top: '100%',
                }}
              >
                <ul
                  {...getMenuProps()}
                  className={cx(
                    'list mv0 pl0 bl br bb b--silver shadow-4 br2 br--bottom',
                    disabled ? 'bg-light-gray' : 'bg-white'
                  )}
                >
                  {items.map((item, i) => (
                    <li
                      key={item.value}
                      {...getItemProps({ item: item, disabled: disabled })}
                      className={cx('link ph3 pv2 pointer flex items-center', {
                        'bt b--silver': i > 0,
                        'bg-near-white': i === highlightedIndex,
                      })}
                    >
                      <span className="db pv1">
                        <span
                          className={cx({
                            fw7: item === selectedItem,
                            orange:
                              i === highlightedIndex || item === selectedItem,
                          })}
                        >
                          {item.text}
                        </span>
                        {item.description && (
                          <span className="db silver f8 fw4 normal mt1 silver">
                            {item.description}
                          </span>
                        )}
                      </span>
                      {ALLOWED_STATUSES.includes(item.value) && (
                        <StatusBadge
                          status={item.value}
                          size={16}
                          className="ml-auto"
                        />
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </Downshift>
    )
  }
}

const itemShape = {
  text: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string,
}

Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(itemShape)),
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
}

export default Dropdown
